const carouselItems = [
  {
    title: '2026暑期档热映',
    tag: '热播推荐',
    desc: '暑期档大片云集，动作、喜剧、科幻轮番上阵，97影视同步更新，高清画质震撼呈现，陪你度过精彩暑假。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20blockbuster%20movie%20collage%20with%20warm%20golden%20cinematic%20lighting%2C%20action%20film%20aesthetic%2C%20dramatic%20color%20grading%2C%20epic%20scale%2C%20movie%20theater%20ambiance%2C%20rich%20contrast%2C%20no%20text&width=800&height=500&seq=carousel-01-97movie&orientation=landscape',
  },
  {
    title: '高分悬疑剧连播',
    tag: '口碑佳作',
    desc: '精选豆瓣8分以上悬疑好剧，烧脑剧情全程高能，高清画质带你看清每一个细节，不放过任何线索。',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20cinematic%20scene%20with%20dark%20moody%20lighting%2C%20dramatic%20shadows%2C%20suspenseful%20atmosphere%2C%20film%20noir%20aesthetic%2C%20deep%20blues%20and%20warm%20highlights%2C%20no%20text&width=800&height=500&seq=carousel-02-97movie&orientation=landscape',
  },
  {
    title: '经典港片重温',
    tag: '怀旧经典',
    desc: '周星驰喜剧、成龙动作、王家卫文艺，经典港片高清修复版一次看个够，重温那个黄金年代的银幕记忆。',
    img: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20nostalgic%20atmosphere%20with%20warm%20vintage%20tones%2C%20old%20film%20texture%2C%20golden%20age%20movie%20aesthetic%2C%20neon%20signs%20ambiance%2C%20retro%20cinematic%20style%2C%20no%20text&width=800&height=500&seq=carousel-03-97movie&orientation=landscape',
  },
  {
    title: '国漫崛起专题',
    tag: '国风动漫',
    desc: '从大圣归来到哪吒，国漫精品不断涌现。97影视收录最全国漫资源，高清画质呈现每一帧国风之美。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%20with%20warm%20golden%20and%20red%20tones%2C%20traditional%20ink%20painting%20elements%20blended%20with%20modern%20animation%2C%20ethereal%20atmosphere%2C%20cinematic%20lighting%2C%20no%20text&width=800&height=500&seq=carousel-04-97movie&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精选当下最受欢迎的高清影视内容，每日更新，精彩不断
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-primary-500 text-white rounded-md">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}